// Little Sparks Co. — Theme JS

document.addEventListener('DOMContentLoaded', function () {
  initCartDrawer();
  initProductGallery();
  initCharmSwatches();
  initQuantitySelectors();
  initMobileNav();
  initAddToCartForms();
  updateCartCount();
});

/* ---------- Cart Drawer ---------- */
function initCartDrawer() {
  const drawer = document.querySelector('[data-cart-drawer]');
  const overlay = document.querySelector('[data-cart-overlay]');
  const openBtns = document.querySelectorAll('[data-cart-open]');
  const closeBtns = document.querySelectorAll('[data-cart-close]');

  if (!drawer) return;

  function open() {
    drawer.classList.add('open');
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    refreshCartDrawer();
  }
  function close() {
    drawer.classList.remove('open');
    overlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  openBtns.forEach(btn => btn.addEventListener('click', (e) => { e.preventDefault(); open(); }));
  closeBtns.forEach(btn => btn.addEventListener('click', close));
  overlay && overlay.addEventListener('click', close);

  window.LSCartDrawer = { open, close, refresh: refreshCartDrawer };
}

function refreshCartDrawer() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => renderCartDrawer(cart))
    .catch(() => {});
}

function renderCartDrawer(cart) {
  const itemsEl = document.querySelector('[data-cart-items]');
  const totalEl = document.querySelector('[data-cart-total]');
  const emptyEl = document.querySelector('[data-cart-empty]');
  if (!itemsEl) return;

  itemsEl.innerHTML = '';
  if (cart.item_count === 0) {
    if (emptyEl) emptyEl.style.display = 'block';
  } else {
    if (emptyEl) emptyEl.style.display = 'none';
    cart.items.forEach(item => {
      const line = document.createElement('div');
      line.className = 'cart-line';
      line.innerHTML = `
        <img src="${item.image || ''}" alt="${item.product_title}">
        <div style="flex:1">
          <div class="cart-line__title">${item.product_title}</div>
          <div class="cart-line__variant">${item.variant_title || ''}</div>
          <div style="display:flex;justify-content:space-between;align-items:center;">
            <span>${(item.final_price / 100).toFixed(2)} × ${item.quantity}</span>
            <button class="btn btn--outline" style="padding:4px 10px;font-size:0.7rem;" data-remove-line="${item.key}">Remove</button>
          </div>
        </div>`;
      itemsEl.appendChild(line);
    });
  }
  if (totalEl) totalEl.textContent = (cart.total_price / 100).toFixed(2);

  itemsEl.querySelectorAll('[data-remove-line]').forEach(btn => {
    btn.addEventListener('click', () => {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: btn.dataset.removeLine, quantity: 0 })
      }).then(res => res.json()).then(cart => { renderCartDrawer(cart); updateCartCount(cart); });
    });
  });

  updateFreeShippingBar(cart);
}

function updateFreeShippingBar(cart) {
  const bar = document.querySelector('[data-free-shipping-bar]');
  if (!bar) return;
  const threshold = parseFloat(bar.dataset.threshold || '50') * 100;
  const remaining = Math.max(threshold - cart.total_price, 0);
  const pct = Math.min((cart.total_price / threshold) * 100, 100);
  const fill = bar.querySelector('.free-shipping-bar__fill');
  const label = bar.querySelector('[data-free-shipping-label]');
  if (fill) fill.style.width = pct + '%';
  if (label) {
    label.textContent = remaining > 0
      ? `You're $${(remaining / 100).toFixed(2)} away from free shipping!`
      : `You've unlocked free shipping! 🎉`;
  }
}

function updateCartCount(cartData) {
  const countEls = document.querySelectorAll('[data-cart-count]');
  if (!countEls.length) return;
  if (cartData) {
    countEls.forEach(el => { el.textContent = cartData.item_count; });
    return;
  }
  fetch('/cart.js').then(res => res.json()).then(cart => {
    countEls.forEach(el => { el.textContent = cart.item_count; });
  });
}

/* ---------- Add to cart forms (AJAX) ---------- */
function initAddToCartForms() {
  document.querySelectorAll('[data-product-form]').forEach(form => {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const formData = new FormData(form);
      const submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Adding...'; }

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
        .then(res => res.json())
        .then(() => {
          updateCartCount();
          if (window.LSCartDrawer) window.LSCartDrawer.open();
        })
        .catch(err => console.error('Add to cart failed', err))
        .finally(() => {
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Add to Cart'; }
        });
    });
  });
}

/* ---------- Product gallery ---------- */
function initProductGallery() {
  document.querySelectorAll('[data-gallery]').forEach(gallery => {
    const main = gallery.querySelector('[data-gallery-main]');
    const thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
        if (main) main.src = thumb.dataset.fullSrc || thumb.src;
      });
    });
  });
}

/* ---------- Charm / variant swatches ---------- */
function initCharmSwatches() {
  document.querySelectorAll('[data-swatch-group]').forEach(group => {
    const swatches = group.querySelectorAll('.swatch, .charm-swatch');
    swatches.forEach(swatch => {
      const input = swatch.querySelector('input');
      if (!input) return;
      // Let the native label click check the radio itself (don't set
      // input.checked here — doing so before the browser's own default
      // action can suppress the native 'change' event it would otherwise
      // fire, which breaks anything listening for 'change' downstream).
      input.addEventListener('change', () => {
        swatches.forEach(s => s.classList.remove('selected'));
        swatch.classList.add('selected');
      });
    });
  });
}

/* ---------- Quantity selectors ---------- */
function initQuantitySelectors() {
  document.querySelectorAll('[data-qty-selector]').forEach(sel => {
    const input = sel.querySelector('input');
    sel.querySelectorAll('[data-qty-minus]').forEach(btn => btn.addEventListener('click', () => {
      input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
    }));
    sel.querySelectorAll('[data-qty-plus]').forEach(btn => btn.addEventListener('click', () => {
      input.value = parseInt(input.value || '1', 10) + 1;
    }));
  });
}

/* ---------- Mobile nav ---------- */
function initMobileNav() {
  const toggle = document.querySelector('[data-mobile-nav-toggle]');
  const nav = document.querySelector('[data-mobile-nav]');
  if (!toggle || !nav) return;
  toggle.addEventListener('click', () => nav.classList.toggle('open'));
}
